import { Injectable, inject } from "@angular/core";
import { ContentGeneratorResource } from "core/stages-client";
import TranslationAttributes = stages.contentgeneratorservice.TranslationAttributes;
import PromptType = stages.contentgeneratorservice.core.PromptType;
import Prompt = stages.common.Prompt;
import SequenceLevel = stages.contentgenerator.SequenceLevel;

@Injectable({ providedIn: "root" })
export class AiService {
	private cg = inject(ContentGeneratorResource);

	async getChildElementNamesList(
		workspaceId: string,
		type: string,
		pv: string,
		identity: string,
		promptId: string,
		generatedNames: string[],
		sequenceLevel: SequenceLevel,
		numberOfChildrenToCreate?: number,
	): Promise<string[]> {
		return this.cg.generateElementNames(workspaceId, type, identity, {
			pv: pv,
			promptId: promptId,
			numberOfChildrenToCreate: numberOfChildrenToCreate,
			sequenceLevel: sequenceLevel,
			generatedNames: generatedNames,
		});
	}

	async getPromptTemplates(
		workspaceId: string,
		type: string,
		pv: string,
		identity: string,
		promptType: PromptType,
	): Promise<Prompt[]> {
		if (workspaceId && type && pv && identity) {
			return this.cg.getPrompts(workspaceId, type, identity, {
				pv: pv,
				promptType: promptType,
			});
		}
		return [];
	}

	async getTextTranslation(
		workspaceId: string,
		type: string,
		pv: string,
		identity: string,
		sourceLanguage: string,
		targetLanguage: string,
		aiTranslationAttributes: TranslationAttributes,
	): Promise<TranslationAttributes> {
		return this.cg.translate(workspaceId, type, identity, aiTranslationAttributes, {
			pv,
			sourceLanguage,
			targetLanguage,
		});
	}
}
